import { useMemo } from 'react';

import map from 'lodash/map';

import { Select, useTransformSelectValue } from '@sbv-clients/ui-shared';

import { useEmployeesGetByDepartmentAndPosition } from '../service/hr';
import { useAppendAllOption, withSanitiseFilterIdValue } from './util';
import useAutoSelectValue from './util/use-auto-select-value';

export function EmployeeFilterByDepartmentAndPositionFilter({
  withAllOption = false,
  autoSelectIfEmpty = false,
  useContextFn,
  errorMessages = {},
}: {
  withAllOption?: boolean;
  autoSelectIfEmpty?: boolean;
  useContextFn: () => {
    facilityId?: number;
    departmentId: number;
    positionId: number;
    employeeId: number;
    onEmployeeIdChange: (value: number) => void;
  };
  errorMessages?: Record<string, string>;
}) {
  const {
    facilityId,
    departmentId,
    positionId,
    employeeId: value,
    onEmployeeIdChange: onChange,
  } = useContextFn();

  const { data, isLoading, isSuccess } = useEmployeesGetByDepartmentAndPosition(
    {
      facilityId,
      departmentId,
      positionId: withSanitiseFilterIdValue(positionId),
    }
  );
  const options = useMemo(() => {
    return map(data, (item) => ({
      id: String(item.employeeId),
      label: item.fullName,
      value: item.employeeId as number,
    }));
  }, [data]);
  useAppendAllOption(options, withAllOption);
  useAutoSelectValue({
    value,
    options,
    selectFirstAsDefault: autoSelectIfEmpty,
    callback: onChange,
    isSuccess,
  });

  const handleChange = useTransformSelectValue<number>(onChange);
  const helperText = errorMessages['employeeId'];
  return (
    <Select
      isLoading={isLoading}
      fullWidth
      size="small"
      value={value}
      label="Employee"
      options={options}
      onChange={handleChange}
      error={!!helperText}
      helperText={helperText}
    />
  );
}
